<script>
import Layout from "../../../layouts/main";
import ExportButton from "@/components/export-button";
import axios from "@/axios";
export default {
  components: {
    Layout,
    "export-button": ExportButton
  },
  data() {
    return {
      numeroContrato: this.$store.getters["hideValue/detailId"],
      fields: [
        {
          key: "nombreDocumento",
          label: "Documento",
          sortable: false,
        },
        {
          key: "descarga",
          label: "Descarga",
          sortable: false,
        },
      ],
      tableData: [],
      isBusy: true,
      buttonClicked: undefined
    };
  },
  beforeMount() {
    this.getDocuments();
  },
  methods:{
    back() {
      history.back();
    },
    getDocuments() {
      this.isBusy = true;
      axios
        .get(`/DocumentoContratoLOP?RutEmpresa=${this.$store.getters["rutEmpresa/cuentaSeleccionada"].value}&NumeroContrato=${this.numeroContrato}`)
        .then((docs) => {
          this.tableData = docs.data.datos
          this.isBusy = false;
        })
        .catch(() => {
            this.isBusy = false;
            this.$bvToast.toast(this.$t('lease.request.error.message').toString(), {
                title: this.$t('lease.request.error.nonFound').toString(),
                variant: 'danger',
                solid: true
            });
        });
    },
    downloadDocumento(row){
      this.buttonClicked = row.item.nombreDocumento;
      axios.get(`/DescargarPDFContratoLOP?NombreArchivo=${this.buttonClicked}&NumeroContrato=${this.numeroContrato}`)
      .then(documento => {
        if (documento.data.pdf) {
            const blob = this.b64toBlob(
              documento.data.pdf,
              "application/pdf"
            );
            let fileURL = window.URL.createObjectURL(blob);
            let fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute(
              "download",
              `${row.item.nombreDocumento}.pdf`
            );
            document.body.appendChild(fileLink);

            fileLink.click();
            this.buttonClicked = undefined;
          }else{
            this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
                title: this.$t('lease.pdf.error.download').toString(),
                variant: 'danger',
                solid: true
            });
        }
      })
      .catch(() => this.$bvToast.toast(this.$t('lease.pdf.error.nonFound').toString(), {
          title: this.$t('lease.pdf.error.download').toString(),
          variant: 'danger',
          solid: true
      }));
    },
    b64toBlob(b64Data, contentType = "", sliceSize = 512) {
      const byteCharacters = atob(b64Data);
      const byteArrays = [];

      for (
        let offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, { type: contentType });
      return blob;
    },
  }
};
</script>
<template>
  <Layout>
    <div classs="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <b-row align-h="between" align-v="center" class="mb-3">
              <h4 class="card-tittle">Documentación del contrato</h4>
              <div class="justify-content-end">
                <b-button class="spacingButton" @click="back">Volver</b-button>
                <export-button :data="tableData" fileName="documentos" />
              </div>              
            </b-row>
            <b-row>
              <b-col sm="12" md="6" offset-md="6" lg="4" offset-lg="8">
                <b-form-group label="Contrato" label-for="formrow-name-input">
                  <b-form-input
                    id="formrow-name-input"
                    v-model="numeroContrato"
                    :disabled="true"
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <div class="container">
              <b-table 
              :items="tableData" 
              :fields="fields"
              responsive="sm" 
              :busy="isBusy"
              class="text-center"
              >

                <!-- Inicio Spinner en estado "ocupado" de la tabla -->
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>
                <!-- Fin Spinner en estado "ocupado" de la tabla -->

                <template #cell(descarga)="row">
                  <div class="text-center">
                    <b-button variant="danger" @click="downloadDocumento(row)">
                      <i v-if="buttonClicked !== row.item.nombreDocumento" class="bx bx-download font-size-16 align-middle" />
                      <b-spinner v-else small class="align-middle"></b-spinner>
                      Descargar
                    </b-button>
                  </div>
                </template>

              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.spacingButton{
  margin-right: 1rem;
}
</style>